package org.koin.ksp.generated

import org.koin.core.module.Module
import org.koin.dsl.*


public val com_essntl_features_organization_data_di_OrganizationModule : Module get() = module {
	single() { _ -> com.essntl.features.organization.data.repository.OrganizationRepositoryImpl(supabase=get()) } bind(com.essntl.features.organization.domain.repository.OrganizationRepository::class)
	single() { _ -> com.essntl.features.organization.data.supabase.OrganizationSupabaseDataSource(supabaseClient=get()) } bind(com.essntl.features.organization.data.supabase.OrganizationSupabaseDataSource::class)
}
public val com.essntl.features.organization.data.di.OrganizationModule.module : org.koin.core.module.Module get() = com_essntl_features_organization_data_di_OrganizationModule
